import React from 'react';
// import photoImg from '../../images/photo.png';
import photoImg from 'images/Paul Ryan.jpg';
import DamienOBrienImg from 'images/DamienOBrien.jpg';
import LisaDalyImg from 'images/LisaDaly.jpg';

export default class AboutUs extends React.Component {

  render(){
    return (
      <section className="about-us section-center">
        <div className="section-center-wrapper">
          <div className="hero-block">
            <h4 className="subTitle">
              {/* Since 2007, Prescription Revision has been helping over a thousand GP trainees to succeed
              in both their CCT and CKT MICGP Examinations. We are passionate about delivering key
              concepts on how to succeed in the MICGP exam. We use a range of different formats
              including podcasts, video and text to teach GP trainees. */}
              About Us
            </h4>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="info-block col-md-3">
                <div className="info-block-inner">
                  <img src={photoImg} alt="About Us" className='aboutImg' />
                  <p>
                    Paul Ryan is both a qualified pharmacist and a GP and has a passion for teaching. He completed a postgraduate certificate in teaching and learning and is currently completing a MD.
                  </p>
                </div>
              </div>
              <div className="info-block col-md-3">
                <div className="info-block-inner">
                  <img src={DamienOBrienImg} alt="About Us" className='aboutImg' />
                  <p>
                    Damien O'Brien qualified as a pharmacist in 2018. He is currently Supervising Pharmacist in Adrian Dunne Pharmacy Baldoyle and is also a medical writer for irishpharmacist.ie. He won young pharmacist of the year at the Irish Pharmacy Awards in 2022. He is passionate about creating educational material for pharmacists and pharmacy students.
                  </p>
                </div>
              </div>
              <div className="info-block col-md-3">
                <div className="info-block-inner">
                  <img src={LisaDalyImg} alt="About Us" className='aboutImg' />
                  <p>
                    Lisa Daly is a Royal College of Surgeons graduate and has worked as a hospital pharmacist since qualifying in 2014. She has a postgraduate qualification in Oncology from Newcastle University as is working as a Chief 2 Oncology Pharmacist in a Dublin hospital. Outside of pharmacy, she enjoys spending time with friends and family and her very active toddler!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/informations/AboutUs.js